var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "var(--icon-fill)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2655_195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 25,
    height: 25,
    fill: "var(--icon-fill)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2655_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4583 16.1246C13.3264 16.1246 14.0642 15.8208 14.6719 15.2131C15.2795 14.6055 15.5833 13.8676 15.5833 12.9996C15.5833 12.1315 15.2795 11.3937 14.6719 10.7861C14.0642 10.1784 13.3264 9.87459 12.4583 9.87459C11.5903 9.87459 10.8524 10.1784 10.2448 10.7861C9.63715 11.3937 9.33333 12.1315 9.33333 12.9996C9.33333 13.8676 9.63715 14.6055 10.2448 15.2131C10.8524 15.8208 11.5903 16.1246 12.4583 16.1246ZM12.4583 18.2079C11.0174 18.2079 9.78906 17.7001 8.77344 16.6845C7.75781 15.6689 7.25 14.4406 7.25 12.9996C7.25 11.5586 7.75781 10.3303 8.77344 9.3147C9.78906 8.29907 11.0174 7.79126 12.4583 7.79126C13.8993 7.79126 15.1276 8.29907 16.1432 9.3147C17.1589 10.3303 17.6667 11.5586 17.6667 12.9996C17.6667 14.4406 17.1589 15.6689 16.1432 16.6845C15.1276 17.7001 13.8993 18.2079 12.4583 18.2079ZM5.16667 14.0413H1V11.9579H5.16667V14.0413ZM23.9167 14.0413H19.75V11.9579H23.9167V14.0413ZM11.4167 5.70793V1.54126H13.5V5.70793H11.4167ZM11.4167 24.4579V20.2913H13.5V24.4579H11.4167ZM6.625 8.57251L3.99479 6.04647L5.47917 4.51001L7.97917 7.11418L6.625 8.57251ZM19.4375 21.4892L16.9115 18.859L18.2917 17.4267L20.9219 19.9527L19.4375 21.4892ZM16.8854 7.16626L19.4115 4.53605L20.9479 6.02043L18.3438 8.52043L16.8854 7.16626ZM3.96875 19.9788L6.59896 17.4527L8.03125 18.8329L5.50521 21.4631L3.96875 19.9788Z",
    fill: "var(--icon-fill)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/lightMode.ac26f30d5cb79227e3e8c02429cbe1b5.svg";
export { ForwardRef as ReactComponent };